export default __webpack_public_path__ + "static/media/cs_icon_04_on.82afd167.png";